import { PatientDetailsIncludeEnum } from '@/hooks/patients/useGetPatientDetails';

export const PATIENT_DETAIL_ENDPOINTS = [
  PatientDetailsIncludeEnum.BasicInfo,
  PatientDetailsIncludeEnum.IdentificationInfo,
  PatientDetailsIncludeEnum.ContactDetails
].join(',');
